"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Controls = _styledComponents.default.div.withConfig({
  displayName: "Controls"
})(["display:flex;flex-direction:row;justify-content:flex-start;margin-bottom:0.5rem;*{margin-left:0.25rem;margin-right:0.25rem;&:first-child{margin-left:0;}&:last-child{margin-right:0;}}"]);

var _default = Controls;
exports.default = _default;